import { Table } from "../../../table";
import { useAutoTableRowProvider } from "../../auto-table-row/auto-table-row-provider";
import { AutoTableLoadingCell } from "../../auto-table-loading-cell";
import { IProps } from "./auto-table-column-body.types";

const AutoTableColumnBody = <T,>({ ref, children, excludeRowLink, ...otherProps }: IProps<T>) => {
    const { row, rowLink } = useAutoTableRowProvider();

    return (
        <Table.Td ref={ref} href={excludeRowLink ? null : rowLink} {...otherProps}>
            {row === null ? <AutoTableLoadingCell /> : children(row)}
        </Table.Td>
    );
};

export { AutoTableColumnBody };
